(function (factory) {
  if (typeof define === 'function' && define.amd)
    define(['exports', './kotlin-kotlin-stdlib.js', './compose-imageLoader-image-loader.js', './androidx-compose-runtime-runtime.js', './compose-multiplatform-core-compose-ui-ui-graphics.js', './compose-imageLoader-extension-ktor-network.js', './compose-imageLoader-extension-svg.js'], factory);
  else if (typeof exports === 'object')
    factory(module.exports, require('./kotlin-kotlin-stdlib.js'), require('./compose-imageLoader-image-loader.js'), require('./androidx-compose-runtime-runtime.js'), require('./compose-multiplatform-core-compose-ui-ui-graphics.js'), require('./compose-imageLoader-extension-ktor-network.js'), require('./compose-imageLoader-extension-svg.js'));
  else {
    if (typeof globalThis['kotlin-kotlin-stdlib'] === 'undefined') {
      throw new Error("Error loading module 'compose-imageLoader-image-loader-singleton'. Its dependency 'kotlin-kotlin-stdlib' was not found. Please, check whether 'kotlin-kotlin-stdlib' is loaded prior to 'compose-imageLoader-image-loader-singleton'.");
    }
    if (typeof globalThis['compose-imageLoader-image-loader'] === 'undefined') {
      throw new Error("Error loading module 'compose-imageLoader-image-loader-singleton'. Its dependency 'compose-imageLoader-image-loader' was not found. Please, check whether 'compose-imageLoader-image-loader' is loaded prior to 'compose-imageLoader-image-loader-singleton'.");
    }
    if (typeof globalThis['androidx-compose-runtime-runtime'] === 'undefined') {
      throw new Error("Error loading module 'compose-imageLoader-image-loader-singleton'. Its dependency 'androidx-compose-runtime-runtime' was not found. Please, check whether 'androidx-compose-runtime-runtime' is loaded prior to 'compose-imageLoader-image-loader-singleton'.");
    }
    if (typeof globalThis['compose-multiplatform-core-compose-ui-ui-graphics'] === 'undefined') {
      throw new Error("Error loading module 'compose-imageLoader-image-loader-singleton'. Its dependency 'compose-multiplatform-core-compose-ui-ui-graphics' was not found. Please, check whether 'compose-multiplatform-core-compose-ui-ui-graphics' is loaded prior to 'compose-imageLoader-image-loader-singleton'.");
    }
    if (typeof globalThis['compose-imageLoader-extension-ktor-network'] === 'undefined') {
      throw new Error("Error loading module 'compose-imageLoader-image-loader-singleton'. Its dependency 'compose-imageLoader-extension-ktor-network' was not found. Please, check whether 'compose-imageLoader-extension-ktor-network' is loaded prior to 'compose-imageLoader-image-loader-singleton'.");
    }
    if (typeof globalThis['compose-imageLoader-extension-svg'] === 'undefined') {
      throw new Error("Error loading module 'compose-imageLoader-image-loader-singleton'. Its dependency 'compose-imageLoader-extension-svg' was not found. Please, check whether 'compose-imageLoader-extension-svg' is loaded prior to 'compose-imageLoader-image-loader-singleton'.");
    }
    globalThis['compose-imageLoader-image-loader-singleton'] = factory(typeof globalThis['compose-imageLoader-image-loader-singleton'] === 'undefined' ? {} : globalThis['compose-imageLoader-image-loader-singleton'], globalThis['kotlin-kotlin-stdlib'], globalThis['compose-imageLoader-image-loader'], globalThis['androidx-compose-runtime-runtime'], globalThis['compose-multiplatform-core-compose-ui-ui-graphics'], globalThis['compose-imageLoader-extension-ktor-network'], globalThis['compose-imageLoader-extension-svg']);
  }
}(function (_, kotlin_kotlin, kotlin_io_github_qdsfdhvh_image_loader, kotlin_androidx_compose_runtime_runtime, kotlin_org_jetbrains_compose_ui_ui_graphics, kotlin_io_github_qdsfdhvh_ktor_network, kotlin_io_github_qdsfdhvh_svg) {
  'use strict';
  //region block: imports
  var VOID = kotlin_kotlin.$_$.d;
  var ImageLoader = kotlin_io_github_qdsfdhvh_image_loader.$_$.r;
  var Unit_instance = kotlin_kotlin.$_$.o3;
  var bitmapMemoryCacheConfig = kotlin_io_github_qdsfdhvh_image_loader.$_$.f;
  var imageMemoryCacheConfig = kotlin_io_github_qdsfdhvh_image_loader.$_$.g;
  var painterMemoryCacheConfig = kotlin_io_github_qdsfdhvh_image_loader.$_$.h;
  var ImageRequest = kotlin_io_github_qdsfdhvh_image_loader.$_$.k;
  var Companion_getInstance = kotlin_androidx_compose_runtime_runtime.$_$.w2;
  var rememberImageAction = kotlin_io_github_qdsfdhvh_image_loader.$_$.s;
  var Companion_getInstance_0 = kotlin_org_jetbrains_compose_ui_ui_graphics.$_$.a4;
  var rememberImagePainter = kotlin_io_github_qdsfdhvh_image_loader.$_$.t;
  var staticCompositionLocalOf = kotlin_androidx_compose_runtime_runtime.$_$.l2;
  var Companion_instance = kotlin_io_github_qdsfdhvh_image_loader.$_$.v;
  var Companion_instance_0 = kotlin_io_github_qdsfdhvh_ktor_network.$_$.b;
  var get_defaultFileSystem = kotlin_io_github_qdsfdhvh_image_loader.$_$.p;
  var setupKtorComponents = kotlin_io_github_qdsfdhvh_ktor_network.$_$.a;
  var setupBase64Components = kotlin_io_github_qdsfdhvh_image_loader.$_$.c;
  var setupSvgComponents = kotlin_io_github_qdsfdhvh_svg.$_$.a;
  var setupSkiaComponents = kotlin_io_github_qdsfdhvh_image_loader.$_$.e;
  var setupCommonComponents = kotlin_io_github_qdsfdhvh_image_loader.$_$.d;
  var protoOf = kotlin_kotlin.$_$.eh;
  var initMetadataForClass = kotlin_kotlin.$_$.cg;
  //endregion
  //region block: pre-declaration
  initMetadataForClass(ImageLoaderProvidableCompositionLocal, 'ImageLoaderProvidableCompositionLocal');
  //endregion
  function get_LocalImageLoader() {
    _init_properties_LocalImageLoader_kt__yxe8hp();
    return LocalImageLoader;
  }
  var LocalImageLoader;
  function createDefault(_this__u8e3s4) {
    _init_properties_LocalImageLoader_kt__yxe8hp();
    return ImageLoader(VOID, createDefault$lambda);
  }
  function createDefault$lambda($this$ImageLoader) {
    _init_properties_LocalImageLoader_kt__yxe8hp();
    $this$ImageLoader.oy4(createDefault$lambda$lambda);
    $this$ImageLoader.ny4(createDefault$lambda$lambda_0);
    return Unit_instance;
  }
  function createDefault$lambda$lambda($this$components) {
    _init_properties_LocalImageLoader_kt__yxe8hp();
    setupDefaultComponents($this$components);
    return Unit_instance;
  }
  function createDefault$lambda$lambda_0($this$interceptor) {
    _init_properties_LocalImageLoader_kt__yxe8hp();
    bitmapMemoryCacheConfig($this$interceptor, VOID, VOID, createDefault$lambda$lambda$lambda);
    imageMemoryCacheConfig($this$interceptor, VOID, VOID, createDefault$lambda$lambda$lambda_0);
    painterMemoryCacheConfig($this$interceptor, VOID, VOID, createDefault$lambda$lambda$lambda_1);
    return Unit_instance;
  }
  function createDefault$lambda$lambda$lambda($this$bitmapMemoryCacheConfig) {
    _init_properties_LocalImageLoader_kt__yxe8hp();
    $this$bitmapMemoryCacheConfig.dy6(33554432);
    return Unit_instance;
  }
  function createDefault$lambda$lambda$lambda_0($this$imageMemoryCacheConfig) {
    _init_properties_LocalImageLoader_kt__yxe8hp();
    $this$imageMemoryCacheConfig.dy6(50);
    return Unit_instance;
  }
  function createDefault$lambda$lambda$lambda_1($this$painterMemoryCacheConfig) {
    _init_properties_LocalImageLoader_kt__yxe8hp();
    $this$painterMemoryCacheConfig.dy6(50);
    return Unit_instance;
  }
  var properties_initialized_LocalImageLoader_kt_pv083p;
  function _init_properties_LocalImageLoader_kt__yxe8hp() {
    if (!properties_initialized_LocalImageLoader_kt_pv083p) {
      properties_initialized_LocalImageLoader_kt_pv083p = true;
      LocalImageLoader = createImageLoaderProvidableCompositionLocal();
    }
  }
  function rememberImageAction_0(url, imageLoader, $composer, $changed, $default) {
    var imageLoader_0 = imageLoader;
    var $composer_0 = $composer;
    $composer_0.k30(1836487882);
    if (!(($default & 2) === 0)) {
      // Inline function 'com.seiko.imageloader.ImageLoaderProvidableCompositionLocal.current' call
      var $composer_1 = $composer_0;
      // Inline function 'androidx.compose.runtime.CompositionLocal.current' call
      var this_0 = get_LocalImageLoader().tyi_1;
      var $composer_2 = $composer_1;
      imageLoader_0 = $composer_2.u31(this_0);
    }
    $composer_0.k30(-903528985);
    // Inline function 'androidx.compose.runtime.cache' call
    var invalid = ($changed & 14 ^ 6) > 4 && $composer_0.k31(url) || ($changed & 6) === 4;
    // Inline function 'kotlin.let' call
    var it = $composer_0.i31();
    var tmp;
    if (invalid || it === Companion_getInstance().f30_1) {
      // Inline function 'com.seiko.imageloader.model.ImageRequest' call
      var value = ImageRequest(rememberImageAction$lambda(url));
      $composer_0.j31(value);
      tmp = value;
    } else {
      tmp = it;
    }
    var tmp1_group = tmp;
    $composer_0.l30();
    var request = tmp1_group;
    var tmp_0 = imageLoader_0;
    var tmp0 = rememberImageAction(request, tmp_0, null, $composer_0, 112 & $changed, 4);
    $composer_0.l30();
    return tmp0;
  }
  function rememberImagePainter_0(url, imageLoader, filterQuality, placeholderPainter, errorPainter, $composer, $changed, $default) {
    var imageLoader_0 = imageLoader;
    var filterQuality_0 = filterQuality;
    var placeholderPainter_0 = placeholderPainter;
    var errorPainter_0 = errorPainter;
    var $composer_0 = $composer;
    $composer_0.k30(2108432172);
    if (!(($default & 2) === 0)) {
      // Inline function 'com.seiko.imageloader.ImageLoaderProvidableCompositionLocal.current' call
      var $composer_1 = $composer_0;
      // Inline function 'androidx.compose.runtime.CompositionLocal.current' call
      var this_0 = get_LocalImageLoader().tyi_1;
      var $composer_2 = $composer_1;
      imageLoader_0 = $composer_2.u31(this_0);
    }
    if (!(($default & 4) === 0))
      filterQuality_0 = Companion_getInstance_0().y6h_1;
    if (!(($default & 8) === 0))
      placeholderPainter_0 = null;
    if (!(($default & 16) === 0))
      errorPainter_0 = null;
    $composer_0.k30(497022528);
    // Inline function 'androidx.compose.runtime.cache' call
    var invalid = ($changed & 14 ^ 6) > 4 && $composer_0.k31(url) || ($changed & 6) === 4;
    // Inline function 'kotlin.let' call
    var it = $composer_0.i31();
    var tmp;
    if (invalid || it === Companion_getInstance().f30_1) {
      // Inline function 'com.seiko.imageloader.model.ImageRequest' call
      var value = ImageRequest(rememberImagePainter$lambda(url));
      $composer_0.j31(value);
      tmp = value;
    } else {
      tmp = it;
    }
    var tmp1_group = tmp;
    $composer_0.l30();
    var request = tmp1_group;
    var tmp0 = rememberImagePainter(request, imageLoader_0, filterQuality_0, placeholderPainter_0, errorPainter_0, $composer_0, 112 & $changed | 896 & $changed | 7168 & $changed | 57344 & $changed, 0);
    $composer_0.l30();
    return tmp0;
  }
  function rememberImageAction$lambda($data) {
    return function ($this$ImageRequest) {
      $this$ImageRequest.gye($data);
      return Unit_instance;
    };
  }
  function rememberImagePainter$lambda($data) {
    return function ($this$ImageRequest) {
      $this$ImageRequest.gye($data);
      return Unit_instance;
    };
  }
  var com_seiko_imageloader_option_AsyncSizeResolver$stable;
  var com_seiko_imageloader_ui_CachedPositionAndSize$stable;
  function createImageLoaderProvidableCompositionLocal() {
    return new ImageLoaderProvidableCompositionLocal(staticCompositionLocalOf(createImageLoaderProvidableCompositionLocal$lambda));
  }
  function createImageLoaderProvidableCompositionLocal$lambda() {
    return createDefault(Companion_instance);
  }
  function setupDefaultComponents(_this__u8e3s4, httpClient) {
    httpClient = httpClient === VOID ? Companion_instance_0.wyg() : httpClient;
    setupDefaultComponents_0(_this__u8e3s4, null, httpClient);
  }
  function setupDefaultComponents_0(_this__u8e3s4, density, httpClient, maxParallelism, fileSystem) {
    density = density === VOID ? null : density;
    httpClient = httpClient === VOID ? Companion_instance_0.wyg() : httpClient;
    maxParallelism = maxParallelism === VOID ? 4 : maxParallelism;
    fileSystem = fileSystem === VOID ? get_defaultFileSystem() : fileSystem;
    setupKtorComponents(_this__u8e3s4, httpClient);
    setupBase64Components(_this__u8e3s4);
    setupSvgComponents(_this__u8e3s4, density);
    setupSkiaComponents(_this__u8e3s4, maxParallelism);
    setupCommonComponents(_this__u8e3s4, fileSystem);
  }
  var com_seiko_imageloader_ImageLoaderProvidableCompositionLocal$stable;
  function ImageLoaderProvidableCompositionLocal(delegate) {
    this.tyi_1 = delegate;
  }
  //region block: init
  com_seiko_imageloader_option_AsyncSizeResolver$stable = 8;
  com_seiko_imageloader_ui_CachedPositionAndSize$stable = 0;
  com_seiko_imageloader_ImageLoaderProvidableCompositionLocal$stable = 0;
  //endregion
  //region block: exports
  _.$_$ = _.$_$ || {};
  _.$_$.a = rememberImageAction_0;
  _.$_$.b = rememberImagePainter_0;
  //endregion
  return _;
}));

//# sourceMappingURL=compose-imageLoader-image-loader-singleton.js.map
